import { lazy } from "react";
import { defineWebModule } from "@tc/ui";
import { manifest } from "./manifest.js";

// Pages load on first visit, so the app starts fast.
const AssetPage = lazy(() => import("./web/AssetPage.js").then((m) => ({ default: m.AssetPage })));
const AssetsPage = lazy(() => import("./web/AssetsPage.js").then((m) => ({ default: m.AssetsPage })));
const JobPage = lazy(() => import("./web/JobPage.js").then((m) => ({ default: m.JobPage })));
const JobsPage = lazy(() => import("./web/JobsPage.js").then((m) => ({ default: m.JobsPage })));
const ReportPage = lazy(() => import("./web/ReportPage.js").then((m) => ({ default: m.ReportPage })));
const SettingsPage = lazy(() => import("./web/SettingsPage.js").then((m) => ({ default: m.SettingsPage })));
const ScanPage = lazy(() => import("./web/StatsPage.js").then((m) => ({ default: m.ScanPage })));
const StatsPage = lazy(() => import("./web/StatsPage.js").then((m) => ({ default: m.StatsPage })));

export default defineWebModule({
  manifest,
  pages: {
    "": JobsPage,
    "/new": ReportPage,
    "/job": JobPage,
    "/assets": AssetsPage,
    "/assets/item": AssetPage,
    "/scan": ScanPage,
    "/stats": StatsPage,
    "/settings": SettingsPage,
  },
});
